import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Class created for the purpose as helpers for obtaining the context of a specific runtine
 */
@Injectable({
    providedIn: 'root'
})
export class ContextService {

    private wc: boolean = environment.isWc;
    private mode: string = environment.mode;
    private mobile: boolean = environment.isMobile;
    private cookieName: string;

    constructor() {}

    /**
     * Helper to get if we current runtime is on web component mode
     * @returns boolean
     * - true when front is running on fast track mode
     * - false when front is running on public or private mode
     */
    public isWC = (): boolean => {
        return this.wc;
    }

    /**
     * Helper to get if we current runtime is on web component mode
     * @returns boolean
     * - true when front is running on fast track mode
     * - false when front is running on public or private mode
     */
    public isMobile = (): boolean => {
        return this.mobile;
    }

    /**
     * Helper that returns the platform type that the current
     * @returns string WEB-PF | WEB | PF | IN | MB-ANDROID | MB-IOD depending on the current mode used
     */
    public getMode = (): string => {
        return this.mode;
    }

    /**
     * Helper that returns wether the current runtime is on private site
     * @returns boolean true if current mode is IN or PF
     */
    public isPrivateSite = (): boolean => this.mode === 'IN' || this.mode === 'PF';

    public isPublicSite = (): boolean => this.mode === 'WEB' || this.mode === 'WEB-PF';

    /**
     * Helper that returns wether the current runtime is on executive mode
     * @returns boolean true if current mode is IN or PF
     */
    public isExecutiveMode = (): boolean => this.mode === 'WEB-PF' || this.mode === 'PF';

    public isPrivateOmni1 = (): boolean => this.mode === 'IN';

    public isPrivateOmni2 = (): boolean => this.mode === 'PF';

    public isPublicOmni1 = (): boolean => this.mode === 'WEB';

    public isPublicOmni2 = (): boolean => this.mode === 'WEB-PF';

    /**
     * Helper that returns wether the current runtime is on not client executive mode (Public site for executives)
     * @returns boolean true if current mode is IN or PF
     */
    public isNotClientExecutive = (): boolean => this.mode === 'WEB-PF';

    public getChannelName() {
        return this.mobile ? 'Mobile' : 'Web';
    }

    public getCookie(cookieName: string) {
        this.cookieName = document.cookie.split('; ').find((row) => row.startsWith(cookieName + '=')).split('=')[1];
        return this.cookieName;
    }
}
